import api from 'api/client';
import { ENDPOINTS } from 'api/endpoints';
import { FavoriteProduct } from 'types/customer';
import { OrderSummary } from 'types/order';
import { asOrderList } from 'utils/mapStoreOrder';

interface StoreFavoriteApi {
  sku?: string;
  Sku?: string;
  slug?: string;
  Slug?: string;
  name?: string;
  Name?: string;
  price?: number;
  Price?: number;
  imageUrl?: string;
  ImageUrl?: string;
  createdAt?: string;
  CreatedAt?: string;
}

const mapFavorite = (data: StoreFavoriteApi): FavoriteProduct => {
  const sku = data.sku || data.Sku || '';
  return {
    productId: sku,
    slug: data.slug || data.Slug || sku,
    name: data.name || data.Name || sku,
    price: Number(data.price ?? data.Price ?? 0),
    imageUrl: data.imageUrl || data.ImageUrl,
    addedAt: data.createdAt || data.CreatedAt || new Date().toISOString(),
  };
};

const favoriteService = {
  getFavorites: async (): Promise<FavoriteProduct[]> => {
    const response = await api.get<StoreFavoriteApi[]>(ENDPOINTS.ACCOUNT_FAVORITES);
    const data = response.data;
    if (!Array.isArray(data)) return [];
    return data.map(mapFavorite);
  },

  addFavorite: async (productId: string): Promise<void> => {
    await api.post(ENDPOINTS.ACCOUNT_FAVORITES, { sku: productId });
  },

  removeFavorite: async (productId: string): Promise<void> => {
    await api.delete(ENDPOINTS.ACCOUNT_FAVORITE(productId));
  },

  getHistory: async (): Promise<OrderSummary[]> => {
    const response = await api.get(ENDPOINTS.ACCOUNT_HISTORY);
    return asOrderList(response.data);
  },
};

export default favoriteService;
